import api from './api';

export const holdService = {
  createHold:  (data)       => api.post('/holds', data),
  releaseHold: (holdId)     => api.delete(`/holds/${holdId}`),
  getMyHold:   ()           => api.get('/holds/my'),
  getAllHolds:  (params = {}) => api.get('/holds', { params }),
};
